import { useEffect } from 'react';

import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import Clickable from '@perpay-web/components/base/Clickable/Clickable';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './UserVerificationHelpModal.scss';

const UserVerificationHelpModal = ({
    className,
    onClose,
    onEditPhoneNumber,
    launchSupportTool,
    onLoadPageView,
}) => {
    useEffect(() => {
        if (onLoadPageView) {
            onLoadPageView();
        }
    }, [onLoadPageView]);

    return (
        <BottomSheet
            onClose={onClose}
            className={getClassName(styles['modal-container'], className)}
            contentClassName={styles['bottom-sheet-content']}
            showClose={false}
            allowDismissal={false}
        >
            <Stack className={styles['modal-content']}>
                <h2 className={styles.title}>Trouble Verifying?</h2>
                <Stack className={styles.options}>
                    <Clickable
                        className={styles.option}
                        onClick={onEditPhoneNumber}
                    >
                        Edit phone number
                        <div className={styles['arrow-right']} />
                    </Clickable>
                    <Clickable
                        className={styles.option}
                        onClick={launchSupportTool}
                    >
                        Contact us
                        <div className={styles['arrow-right']} />
                    </Clickable>
                </Stack>
                <CustomButton
                    onClick={onClose}
                    className={getClassName(
                        styles['modal-footer'],
                        styles.button,
                    )}
                >
                    Cancel
                </CustomButton>
            </Stack>
        </BottomSheet>
    );
};

export default UserVerificationHelpModal;
